import React from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Flex,
    Text,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CloseIcon} from '../icons'
import {FormattedMessage} from 'react-intl'

const GigyaModal = ({
    isOpen,
    onClose,
    children,
    wishlist = false,
    variant = 'default',
    isNotifyMe = false,
    ...props
}) => {
    const styles = useStyleConfig('GigyaModal', {variant})

    return (
        <Flex
            {...styles.modal}
            display={isOpen ? 'block' : 'none'}
            flexDirection="column"
            role="dialog"
            aria-labelledby="gigya-modal-title"
            aria-modal="true"
            {...props}
        >
            <Flex {...styles.content}>
                <>
                    <Text {...styles.text} id="gigya-modal-title">
                        {isNotifyMe ? (
                            <FormattedMessage
                                defaultMessage="To receive a notification about this product, you must log in."
                                id="login_form.message.register_to_notify"
                            />
                        ) : wishlist ? (
                            <FormattedMessage
                                defaultMessage="To receive a notification about this product, you must log in to save your wishlist."
                                id="login_form.message.register_to_save_wishlist"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Forgot your password?"
                                id="login_form.message.forgot_your_password"
                            />
                        )}
                    </Text>
                    {wishlist && (
                        <Text {...styles.title}>
                            <FormattedMessage
                                defaultMessage="Already Registered User?"
                                id="login_form.message.already_registered"
                            />
                        </Text>
                    )}
                </>
                <Button {...styles.close} onClick={() => onClose()}>
                    <CloseIcon />
                </Button>
                {children}
            </Flex>
        </Flex>
    )
}

GigyaModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    variant: PropTypes.string,
    wishlist: PropTypes.bool,
    isNotifyMe: PropTypes.bool,
}

export default GigyaModal
